interface ISecuritySectionProps {
    numberBadAccess: number;
    multifactorAuthenticationNumberBadAccess: number;
    periodOfInactivityDays: number;
}

function SecuritySection(props: ISecuritySectionProps): JSX.Element {
    const { numberBadAccess, multifactorAuthenticationNumberBadAccess, periodOfInactivityDays } = props;

    return (
        <div>
            <div className="view-section-header">
                <h3 className="view-section-title">{cacheStore.GetString("SecurityLabel")}</h3>
            </div>
            <div className="view-section-body">
                {numberBadAccess > 0 && (
                    <div className="row">
                        <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                            <label className="form-label">{cacheStore.GetString("NumberOfFailedLoginLabel")}</label>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                            <strong>{numberBadAccess}</strong>
                        </div>
                    </div>
                )}
                {multifactorAuthenticationNumberBadAccess > 0 && (
                    <div className="row">
                        <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                            <label className="form-label">{cacheStore.GetString("MultifactorAuthentication_NumberOfFailedMfaAttemptsLabel")}</label>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                            <strong>{multifactorAuthenticationNumberBadAccess}</strong>
                        </div>
                    </div>
                )}
                {periodOfInactivityDays > 0 && (
                    <div className="row">
                        <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                            <label className="form-label">{cacheStore.GetString("DeactivateAccountsAfterLabel")}</label>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                            <strong>{periodOfInactivityDays} {cacheStore.GetString("DaysLabel").toLowerCase()} {cacheStore.GetString("OfInactivityLabel")}</strong>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default SecuritySection;
